import { type CustomMenuItemProps, useGridMenuItem } from "ag-grid-react"
import React from "react"

export const HideColumnItem = ({ name }: CustomMenuItemProps) => {
  useGridMenuItem({
    configureDefaults: () => true,
  })
  return (
    <div>
      <span className="ag-menu-option-part ag-menu-option-icon ag-icon-filter" role="presentation">
        {/* eslint-disable-next-line react/no-unknown-property */}
        <span className="ag-icon ag-icon-eye-slash" unselectable="on" role="presentation"></span>
      </span>
      <span className="ag-menu-option-part ag-menu-option-text">{name}</span>
    </div>
  )
}
